module.exports = __webpack_public_path__ + "static/Kroll-4a204bd797d98a4de9ed191bff4eb733.png";